import { gql } from "@apollo/client";
import { TRANSACTION_FRAGMENT } from "@graphql/fragments";

export const SET_FINANCIAL_PROFILE = gql`
  mutation setUserFinancialProfile(
    $investmentPriority: UserInvestmentPriority
    $investmentHorizon: UserInvestmentHorizon
    $downturnReaction: UserDownturnReaction
    $employmentStatus: UserEmploymentStatus
    $employerName: String
    $employerAddressUnitNo: String
    $employerAddressStreet: String
    $employerAddressCity: String
    $employerAddressState: String
    $employerAddressCountry: String
    $employerAddressPostalCode: String
    $occupation: OccupationTitle
    $industry: OccupationIndustry
    $sourceOfFunds: UserSourceOfFunds
    $liquidNetWorth: UserLiquidNetWorth
    $annualIncome: UserAnnualIncome
  ) {
    setUserFinancialProfile(
      input: {
        investmentPriority: $investmentPriority
        investmentHorizon: $investmentHorizon
        downturnReaction: $downturnReaction
        employmentStatus: $employmentStatus
        employerName: $employerName
        employerAddressUnitNo: $employerAddressUnitNo
        employerAddressStreet: $employerAddressStreet
        employerAddressCity: $employerAddressCity
        employerAddressState: $employerAddressState
        employerAddressCountry: $employerAddressCountry
        employerAddressPostalCode: $employerAddressPostalCode
        occupationTitle: $occupation
        occupationIndustry: $industry
        sourceOfFunds: $sourceOfFunds
        liquidNetWorth: $liquidNetWorth
        annualIncome: $annualIncome
      }
    ) {
      id
    }
  }
`;

export const UPDATE_SIP = gql`
  mutation changeRecurringDeposit($sipId: String!, $amountInCents: Int, $frequency: SipFrequency) {
    changeRecurringDeposit(
      input: { sipId: $sipId, amountInCents: $amountInCents, frequency: $frequency }
    ) {
      id
      recurringDepositInCents
      recurringDepositSchedule
      status
    }
  }
`;

export const PAUSE_SIP = gql`
  mutation pauseRecurringDeposit($sipId: String!) {
    pauseRecurringDeposit(input: { sipId: $sipId }) {
      id
      recurringDepositInCents
      recurringDepositSchedule
      status
    }
  }
`;

export const RESUME_SIP = gql`
  mutation resumeRecurringDeposit($sipId: String!) {
    resumeRecurringDeposit(input: { sipId: $sipId }) {
      id
      recurringDepositInCents
      recurringDepositSchedule
      status
    }
  }
`;

export const CANCEL_CONTRIBUTION = gql`
  ${TRANSACTION_FRAGMENT}

  mutation cancelContribution($transactionId: String!) {
    cancelContribution(input: { transactionId: $transactionId }) {
      ...TransactionFragment
    }
  }
`;

export const CREATE_SIP = gql`
  mutation createRecurringDeposit(
    $goalId: String!
    $amountInCents: Int!
    $frequency: SipFrequency!
  ) {
    createRecurringDeposit(
      input: { goalId: $goalId, amountInCents: $amountInCents, frequency: $frequency }
    ) {
      id
      recurringDepositInCents
      recurringDepositSchedule
      status
    }
  }
`;
